import React from "react";

import Loader from "../../components/common/Loader";


function ToolProgressPanel({
  loading,
  isDownloadingShopify = false,
  uploadProgress,
  uploadMessage = "Uploading files to server for processing...",
  processingMessage = "Processing...",
}) {
  if (!loading && !isDownloadingShopify) {
    return null;
  }

  return (
    <div className="tool-progress-panel">
      {isDownloadingShopify ? (
        <Loader message="Fetching real-time inventory from Shopify..." />
      ) : uploadProgress < 100 ? (
        <>
          <div className="progress-bar-container">
            <div
              className="progress-bar-fill"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
          <p className="progress-text">
            {uploadMessage} {uploadProgress}%
          </p>
        </>
      ) : (
        <Loader message={processingMessage} />
      )}
    </div>
  );
}


export default ToolProgressPanel;
